'use strict';

const ListDirective = () => {

  return {
    bindToController: true,
    controller: 'OverlayListController',
    controllerAs: 'listCtrl',
    link: () => {},
    scope: true,
    templateUrl: 'dash/nav/navLeft/overlays/list/overlayList.tpl.html'
  };
};

module.exports = ListDirective;


// WEBPACK FOOTER //
// ./src/app/dash/nav/navLeft/overlays/list/OverlayListDirective.js